<template>
  <nav class="navigation">
    <div class="navigation__wrap">
      <!-- Platform button -->
      <span
        v-if="platform === 'steam'"
        class="navigation__element navigation__platform"
      >
        <a
          class="navigation__link navigation__link--withicon"
          href="https://store.steampowered.com/developer/larianstudios"
          target="_blank"
          id="pad-platform"
          pad-right="go:#pad-home"
          pad-down="go:#pad-play,#pad-get-game,#pad-continue,#pad-merch-main,#pad-onboarding"
          pad-left="run:leaveWebView,left"
          pad-a="click"
          ><iconSteam /> <span> Steam</span></a
        >
      </span>

      <span
        v-if="platform === 'galaxy'"
        class="navigation__element navigation__platform"
      >
        <a
          class="navigation__link navigation__link--withicon"
          href="https://www.gog.com/games?developers=larian-studios"
          target="_blank"
          id="pad-platform"
          pad-right="go:#pad-home"
          pad-down="go:#pad-play,#pad-get-game,#pad-continue,#pad-merch-main,#pad-onboarding"
          pad-left="run:leaveWebView,left"
          pad-a="click"
          ><iconGalaxySmall /> <span> GOG</span></a
        >
      </span>

      <!-- Start button: -->
      <ul v-if="!isSimple" class="navigation__elements">
        <li
          class="navigation__element"
          :class="{
            '-active':
              $route.name === 'bg3' ||
              $route.name === 'dos2' ||
              $route.name === 'dos'
          }"
        >
          <router-link
            :to="{ name: game }"
            class="navigation__link"
            :pad-left="platform ? 'go:#pad-platform' : 'run:leaveWebView,left'"
            pad-right="go:#merch"
            pad-down="go:#pad-play,#pad-get-game,#pad-continue,#pad-merch-main"
            pad-a="click"
            id="pad-home"
          >
            <iconHome /> {{ $t("start") }}
          </router-link>
        </li>

        <!-- Rest of menu: -->
        <li
          v-if="language != 'ru'"
          class="navigation__element"
          :class="{ '-active': $route.name === 'Merch' }"
        >
          <router-link
            :to="{ name: 'Merch' }"
            class="navigation__link"
            pad-left="go:#pad-home"
            pad-right="go:#report-bug"
            pad-down="go:#pad-play,#pad-get-game,#pad-continue,#pad-merch-main"
            pad-a="click"
            id="merch"
            >{{ $t("merch") }}</router-link
          >
        </li>

        <li class="navigation__element external-link">
          <a
            :href="getFeedbackPage"
            class="navigation__link"
            target="_blank"
            id="report-bug"
            pad-left="go:#merch"
            pad-right="go:#pad-help"
            pad-down="go:#pad-play,#pad-get-game,#pad-continue,#pad-merch-main"
            pad-a="click"
            >{{ $t("report_bug") }}</a
          >
        </li>

        <li class="navigation__element external-link">
          <a
            :href="getHelpPage"
            class="navigation__link"
            target="_blank"
            id="pad-help"
            pad-left="go:#report-bug"
            pad-right="go:#pad-forum"
            pad-down="go:#pad-play,#pad-get-game,#pad-continue,#pad-merch-main"
            pad-a="click"
            >{{ $t("help") }}</a
          >
        </li>
        <li class="navigation__element external-link">
          <a
            href="http://forums.larian.com"
            class="navigation__link"
            target="_blank"
            id="pad-forum"
            pad-left="go:#pad-help"
            pad-right="go:#pad-account"
            pad-down="go:#pad-play,#pad-get-game,#pad-continue,#pad-merch-main"
            pad-a="click"
            >{{ $t("forums") }}</a
          >
        </li>
      </ul>

      <div v-if="!isSimple" class="navigation__account">
        <div v-if="user" class="navigation__account--logged">
          <span
            class="navigation__element has-submenu navigation__item--login navigation__item--logged"
            id="pad-account"
            pad-left="go:#pad-forum"
            pad-down="go:#pad-my-account"
            pad-right="go:#pad-back"
            pad-a="hover"
            tabindex="1"
          >
            <span class="navigation__link">
              {{ $t("my_account") }} <span class="online"></span>
            </span>
            <div class="submenu">
              <div class="submenu__border"></div>
              <ul class="submenu__list">
                <li class="submenu__item">
                  <a
                    :href="accountLink"
                    class="submenu__link"
                    id="pad-my-account"
                    pad-up="go:#pad-account"
                    pad-down="go:#pad-logout"
                    pad-left="go:#pad-forum"
                    pad-right="go:#pad-back"
                    target="_blank"
                    rel="noopener noreferrer"
                    >{{ $t("account") }}</a
                  >
                </li>
                <li class="submenu__item">
                  <a
                    href="#"
                    class="submenu__link"
                    id="pad-logout"
                    pad-up="go:#pad-my-account"
                    pad-down="go:#pad-play,#pad-get-game,#pad-continue,#pad-merch-main"
                    pad-left="go:#pad-forum"
                    pad-right="go:#pad-back"
                    target="_blank"
                    rel="noopener noreferrer"
                    @click.prevent="logout"
                  >
                    {{ $t("logout") }}
                  </a>
                </li>
              </ul>
            </div>
          </span>
          <!-- <span class="navigation__element" @click="toggleFriends()">
          <span class="navigation__link"> <iconFriends /> 6</span>
        </span> -->
        </div>

        <span v-else class="navigation__element navigation__item--login">
          <router-link
            :to="{ name: 'Login', query: { game } }"
            class="navigation__link"
            id="pad-account"
            pad-left="go:#pad-forum"
            pad-down="go:#pad-news-1,#pad-merch-widget,#pad-play,#pad-get-game,#pad-continue,#pad-merch-main"
            pad-up="run:leaveWebView,up"
            pad-a="click"
          >
            {{ $t("login") }}
          </router-link>
        </span>
      </div>
      <div v-else class="navigation__logo">
        <img src="~@/assets/img/png/logo-larian.png" alt="" />
      </div>
    </div>
  </nav>
</template>

<script>
import { mapState } from "vuex";

import iconHome from "@/components/Icons/iconHome.vue";
// import iconFriends from "@/components/Icons/iconFriends.vue";
import iconSteam from "@/components/Icons/iconSteamSmall.vue";
import iconGalaxySmall from "@/components/Icons/iconGalaxySmall.vue";

export default {
  components: {
    iconHome,
    // iconFriends,
    iconSteam,
    iconGalaxySmall
  },
  props: {
    isSimple: {
      type: Boolean
    }
  },
  data() {
    return {
      accountLink: `${process.env.VUE_APP_ACCOUNT_API_URL}account`
    };
  },
  mounted() {
    // console.log("game", this.game);
  },
  computed: {
    ...mapState({
      user: state => state.user,
      cacheVersion: state => state.cacheVersion,
      platform: state => state.initPlatform,
      launcherVersion: state => state.launcherVersion,
      game: state => state.game,
      friendsOpened: state => state.friendsOpened,
      language: state => state.language
    }),

    getHelpPage() {
      if (this.game === "bg3") {
        return "https://larian.com/support/baldur-s-gate-3";
      } else if (this.game === "dos2") {
        return "https://larian.com/support/divinity-original-sin-ii";
      } else if (this.game === "dos") {
        return "https://larian.com/support/divinity-original-sin";
      } else {
        return "https://larian.com/support/baldur-s-gate-3";
      }
    },

    getFeedbackPage() {
      if (this.game === "bg3") {
        return `https://larian.com/support/faqs/how-to-submit-a-bug-report_85`;
      } else if (this.game === "dos2") {
        return `https://larian.com/support/divinity-original-sin-ii?ver=${this.launcherVersion}#modal`;
      } else if (this.game === "dos") {
        return `https://larian.com/support/divinity-original-sin?ver=${this.launcherVersion}#modal`;
      } else {
        return `https://larian.com/support/faqs/how-to-submit-a-bug-report_85`;
      }
    }
  },

  methods: {
    toggleFriends() {
      if (!this.friendsOpened) {
        this.$store.dispatch("toggleFriends", true);
      } else {
        this.$store.dispatch("toggleFriends", false);
      }
    },

    logout() {
      this.$store
        .dispatch("logout")
        .then(res => {
          if (res.status) {
            this.$store.dispatch("setUser", null);
            window.location.href = `/${this.cacheVersion}`;
          }
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="scss" scoped>
.navigation {
  font-family: "Gilam SemiBold", sans-serif;
  display: flex;
  padding: 30px 0 0 0;
  position: relative;
  z-index: 100;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: -50%;
    width: 200%;
    height: 112px;
    background-image: linear-gradient(
      180deg,
      rgb(0, 0, 0) 20%,
      rgba(0, 0, 0, 0) 100%
    );
    z-index: -1;
    pointer-events: none;
  }

  &__wrap {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  &__logo {
    margin-left: auto;
  }

  &__link {
    color: $white;
    text-transform: uppercase;
    // font-size: 1.4545455vw;
    font-size: 14px;

    svg {
      margin-right: 5px;
    }

    &--withicon {
      &:hover {
        span:before {
          width: 100%;
        }
      }

      svg {
        margin-right: 5px;
        margin-top: -2px;
      }

      span {
        position: relative;
      }

      span:before {
        content: "";
        position: absolute;
        bottom: -7px;
        width: 0;
        height: 1px;
        background: #ffe176;
        transition: width 0.3s ease;
      }
    }
  }

  &__elements {
    display: flex;
    justify-content: center;
    margin: 0 auto;
    padding: 30px 0 0 0;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;

    .navigation__element {
      position: relative;

      &::before {
        content: "";
        position: absolute;
        bottom: -3px;
        width: 0;
        height: 1px;
        background: $yellow;
        transition: width 0.3s ease;
      }

      &:hover {
        &::before {
          width: 100%;
        }
      }

      &.-active {
        &::before {
          width: 100%;
        }
      }
    }
  }

  &__element {
    display: inline-block;
    padding: 20px 0 0 0;
    margin-right: 27px;
    cursor: pointer;

    &:last-child {
      margin-right: 0;
    }
  }

  &__platform {
    z-index: 1;
    span {
      &::before {
        content: none;
      }
    }
  }

  &__account {
    margin-left: auto;
    z-index: 1;
  }
}

.-has-line {
  position: relative;

  &::before {
    content: "";
    position: absolute;
    bottom: -3px;
    left: 0;
    width: calc(100% - 20px);
    height: 1px;
    background-color: $yellow;
  }
}

.has-submenu > a,
.has-submenu > span {
  display: flex;
  align-items: center;
  color: $white;
  font-size: 16px;
  &::after {
    content: "";
    width: 20px;
    height: 16px;
    background-image: url("/svg/arrow_down_white.svg");
    background-repeat: no-repeat;
    background-position: 50%;
    display: block;
    margin-left: 2px;
    margin-bottom: 2px;
  }
}

.external-link > a {
  &::after {
    content: "";
    width: 12px;
    height: 12px;
    background-color: transparent;
    position: static;
    background-image: url("~@/assets/img/svg/external-link.svg");
    background-repeat: no-repeat;
    background-position: 50%;
    display: inline-block;
    margin-left: 6px;
  }
}

// .icon-bug > a {
//   &::after {
//     content: "";
//     width: 21px;
//     height: 21px;
//     background-color: transparent;
//     position: static;
//     background-image: url("~@/assets/img/svg/icon-ring.svg");
//     background-repeat: no-repeat;
//     background-size: contain;
//     background-position: 50%;
//     display: inline-block;
//     margin-left: 8px;
//     margin-bottom: -4px;
//   }
// }

.has-submenu {
  &:hover {
    .submenu {
      opacity: 1;
      pointer-events: auto;
    }
    .submenu__border {
      transform: scaleX(1) translateX(-50%);
      transition: transform 0.2s ease;
    }

    .submenu__list {
      transform: scaleY(1);
    }

    .submenu__item {
      opacity: 1;
      transform: translateY(0);
      text-transform: uppercase;

      &:first-child {
        transition: transform 0.08s ease 0.3s, opacity 0.1s ease 0.3s;
      }
      &:nth-of-type(2) {
        transition: transform 0.08s ease 0.4s, opacity 0.1s ease 0.4s;
      }
      &:nth-of-type(3) {
        transition: transform 0.08s ease 0.5s, opacity 0.1s ease 0.5s;
      }
      &:nth-of-type(4) {
        transition: transform 0.08s ease 0.6s, opacity 0.1s ease 0.6s;
      }
      &:nth-of-type(5) {
        transition: transform 0.08s ease 0.7s, opacity 0.1s ease 0.7s;
      }
      &:nth-of-type(6) {
        transition: transform 0.08s ease 0.8s, opacity 0.1s ease 0.8s;
      }
      &:nth-of-type(7) {
        transition: transform 0.08s ease 0.9s, opacity 0.1s ease 0.9s;
      }
      &:nth-of-type(8) {
        transition: transform 0.08s ease 1s, opacity 0.1s ease 1s;
      }
    }
  }
}

.submenu {
  position: absolute;
  pointer-events: none;
  padding-top: 5px;
  width: auto;
  margin-left: -2px;
  z-index: 10000;

  &__border {
    position: absolute;
    left: 50%;
    width: 100%;
    height: 1px;
    background: linear-gradient(
      90deg,
      hsla(0, 0%, 100%, 0.15) 0,
      #636a6d 30%,
      #636a6d 50%,
      #636a6d 70%,
      hsla(0, 0%, 100%, 0.15)
    );
    transform: scaleX(0) translateX(-50%);
    transform-origin: left top;
    overflow: hidden;
    transition: transform 0.2s ease 0.4s;
    z-index: 1;
  }

  &__list {
    background: rgba(0, 0, 0, 0.8);
    border-top: 1px solid #636a6d;
    padding: 3rem 5rem;
    width: 100%;
    height: 100%;
    transform: scaleY(0);
    transition: transform 0.2s ease 0.2s;
    transform-origin: top left;
    &:hover {
      .submenu__item:not(:hover) {
        a {
          color: #939393;
        }
      }
    }
  }

  &__item {
    position: relative;
    display: flex;
    align-items: center;
    opacity: 0;
    transform: translateY(10px);
    transition: transform 0.2s linear, opacity 0.2s ease;
    // svg {
    //   margin-bottom: 10px;
    //   margin-left: 8px;
    // }
    a {
      transition: color 0.2s ease;
    }
    &::before {
      content: "";
      position: absolute;
      left: -5.1rem;
      bottom: 19px;
      width: 0;
      height: 1px;
      background-color: $yellow;
      transition: width 0.2s ease;
    }
    &:hover {
      &::before {
        width: 3rem;
      }
    }
    &:last-of-type {
      &::before {
        bottom: 9px;
      }
      .submenu__link {
        margin-bottom: 0;
      }
    }
  }

  &__link {
    display: flex;
    align-items: center;
    color: $white;
    margin-bottom: 10px;
    font-family: "Gilam Book", sans-serif;
    // @include fontSizes(16px, 14px, 16px, 16px, 16px);
    font-size: 14px;
  }
}

.navigation__item--login {
  & > .navigation__link {
    background: url("~@/assets/img/svg/person.svg") no-repeat;
    padding-left: 30px;
  }

  // > .submenu {
  //   margin-left: -15px;
  // }
}

.navigation__item--logged {
  & > .navigation__link {
    position: relative;

    .online {
      position: absolute;
      left: 17px;
      top: 0;
      width: 5px;
      height: 5px;
      background-color: #65e58d;
      border-radius: 100%;
    }
  }
}

@media screen and (min-width: $screen-medium) {
  .navigation {
    &__link {
      font-size: 16px;
    }
  }

  .submenu {
    &__link {
      font-size: 16px;
    }
  }
}

@media screen and (max-height: 800px) {
  .navigation {
    &__logo {
      img {
        width: 55px;
      }
    }
  }
}
</style>
